import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.motivos.delete}
                postUrl={api.proyectos.config.presupuesto.motivos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Motivo de Rechazo ha sido eliminado con éxito."}
                title={"Eliminar Motivo de Rechazo"}
                buttonTitle={"Eliminar Motivo de Rechazo"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                className={"ui-modal-dialog"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Motivo seleccionado</p>
                        <div className="ui-alert ui-alert-danger">
                            <i className="ti ti-trash" aria-hidden="true"></i>
                            <span>Esta acción eliminará el motivo de rechazo seleccionado.</span>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Motivos/Delete.js